export type BuilderSectionLayoutOption = {
  value: string
  label: string
}

export type BuilderPageForAddSection = {
  isCustom?: boolean
  defaultPageType?: string | null
  default_page_type?: string | null
  slug?: string | null
} | null

const NEVER_ADDABLE = new Set([
  "hero",
  "packages",
  "events",
  "group_events",
  "featured_services",
  "review_hero",
  "blog_posts"
])

export const isContactBuilderPage = (currentPage: BuilderPageForAddSection): boolean => {
  if (!currentPage) return false

  const defaultPageType = currentPage.defaultPageType ?? currentPage.default_page_type ?? null

  if (defaultPageType === "contact") return true
  if (defaultPageType !== null && defaultPageType !== undefined) return false

  return currentPage.slug === "contact"
}

export const getAddableSectionLayouts = ({
  availableLayouts,
  currentPage,
  existingLayouts = []
}: {
  availableLayouts: BuilderSectionLayoutOption[]
  currentPage: BuilderPageForAddSection
  existingLayouts?: string[]
}): BuilderSectionLayoutOption[] => {
  const isCustomPage = currentPage?.isCustom === true
  const onContactPage = isContactBuilderPage(currentPage)
  const hasContactSection = existingLayouts.includes("contact")

  const sectionsToFilter = new Set(NEVER_ADDABLE)

  if (!isCustomPage) {
    sectionsToFilter.add("sub_hero")
  }

  if (!onContactPage || hasContactSection) {
    sectionsToFilter.add("contact")
  }

  return availableLayouts.filter((layout) => !sectionsToFilter.has(layout.value))
}
